import { call, put } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';
import apiRequests from 'config/services';
import { takeLatest } from 'redux-saga/effects';
import { sagaGetCalculationProcessStepListingAction } from 'saga/actions/calculationprocessStep';
import { calculationProcessStepConstants } from 'saga/actions/calculationprocessStep';

export function* renameCalculationProcessStepSaga(
  action: PayloadAction<{ uuid: string, name: string }>
): SagaIterator {
  try {
    // Destructure from the action payload
    const { uuid, name } = action.payload;

    // Call your API function with both arguments
    yield call(apiRequests.renameCalculationProcessStep, uuid, name);

    yield put(sagaGetCalculationProcessStepListingAction())      // Refresh the list of assemblies
  } catch (e) {
  }
}

// Listener saga
export function* renameCalculationProcessStepHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(calculationProcessStepConstants.SAGA_RENAME_PROCESS_STEP, renameCalculationProcessStepSaga)
}
